<template>
  <div class="patientTransfer">
    <button
      @click="showOverlay"
      v-if="customerSecurityPolicySettings && !transferredTo && transferredFrom.length === 0"
      class="flex justify-center py-2 px-2 md:px-4 border border-white shadow-sm text-sm font-medium text-white bg-primary-default rounded-full hover:bg-primary-default/50 items-center mr-2"
    >
      <UserIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block" aria-hidden="true" />
      <span class="ml-1">Patiënt overdragen</span>
    </button>
    <v-overlay-large v-if="patientTransferOverlayActive" title="Patient overdragen" @close="closeOverlay">
      <patient-transfer-form @success="closeOverlay" />
    </v-overlay-large>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import VOverlayLarge from '@/components/shared/OverlayLarge.vue';
import PatientTransferForm from './PatientTransferForm.vue';
import { customerSecurityPolicySettings$ } from '@/services';
import { UserIcon } from '@heroicons/vue/20/solid';

export default {
  name: 'PatientTransferButton',
  components: {
    UserIcon,
    VOverlayLarge,
    PatientTransferForm
  },
  props: {
    showTransferButton: {
      type: Boolean,
      required: true
    },
    changeUserForPatientTransfer: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const store = useStore();
    const customerSecurityPolicySettings = ref(null);

    customerSecurityPolicySettings$.subscribe((value) => (customerSecurityPolicySettings.value = value));

    return {
      customerSecurityPolicySettings
    };
  },
  data() {
    return {
      patientTransferOverlayActive: false
    };
  },
  computed: {
    transferredTo() {
      return (this.customerSecurityPolicySettings && this.customerSecurityPolicySettings.transferredTo) || null;
    },
    transferredFrom() {
      return (this.customerSecurityPolicySettings && this.customerSecurityPolicySettings.transferredFrom) || [];
    }
  },
  watch: {
    changeUserForPatientTransfer(value) {
      if (value) {
        this.showOverlay();
      }
    }
  },
  methods: {
    showOverlay() {
      this.patientTransferOverlayActive = true;
    },
    closeOverlay() {
      this.patientTransferOverlayActive = false;
      this.$emit('close');
    }
  }
};
</script>
